import React from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Navbar from '../Navbar';
import Footer from '../Pages/Footer';
import SEO from '../components/SEO';

export default function Realisations() {
  const realisations = useSelector(state => state.homeReducer.realisations);

  return (
    <div className="realisations-page">
      <SEO
        title="Nos Réalisations — Projets Immobiliers SCI MAYEDO"
        description="Découvrez les réalisations immobilières de SCI MAYEDO : résidences, villas et projets livrés en Côte d'Ivoire. La preuve de notre savoir-faire et de notre engagement."
        canonical="/Nos--realisations"
      />
      <Navbar />

      <div className="container__real__header">
        <div className="container__real__header__content">
          <h2 className="md">Nos réalisations</h2>
          <h4>Quelques-unes de nos réalisations en image.</h4>
        </div>
      </div>

      <div className="container">
        <div className="container__realisations">
          {realisations.map(real => (
            <div key={real.id} className="cards__realisations">
              <Link to={`/detail/realisation/${real.id}`}>
                <img src={`${process.env.PUBLIC_URL}/${real.img || real.images?.[0]}`} alt={real.name} />
              </Link>
              <div className="realisations__caption">
                <h5>{real.name}</h5>
                {/* <p>{real.address}</p> */}
              </div>
            </div>
          ))}
        </div>
      </div>

      <Footer />
    </div>
  );
}